export enum AppEntityID {
    Project = 1,
    Task = 2,
    Request = 3,
    Issue = 4,
    Customer = 5,
    User = 6,
    Portfolio = 7,
    AllActivities = 8,
    Payment = 9,
    TimeEntry = 10,
    Expense = 11,
}

export enum PortfolioRole {
    Teamer = "Teamer",
    Viewer = "Viewer",
    Editor = "Editor",
    Manager = "Manager",
}

export enum MetaTypes {
    TreatAsOpen = 0,
    TreatAsHold = 1,
    TreatAsCompleted = 2,
}

export const enum EntityType {
    Portfolio = "Portfolio",
    Customer = "Customer",
    Project = "Project",
    Task = "Task",
    ProjectMember = "ProjectMember",
    Allocation = "Allocation",
    UnnamedResource = "UnnamedResource",
    User = "User",
    Vacation = "Vacation",
    Vacations = "Vacations",
    OtherProjects = "OtherProjects",
    JobRole = "JobRole",
    CustomField = "CustomField",
    Workflow = "Workflow",
    Form = "Form",
    Space = "Space",
    Invoice = "Invoice",
}

export const enum TaskType {
    Task = "Task",
    Issue = "Issue",
    Request = "Request",
}

export enum TaskTypeId {
    Task = 1,
    Issue = 2,
    Request = 3,
}

export const getTaskType = (taskTypeId: TaskTypeId): TaskType => {
    switch (taskTypeId) {
        case TaskTypeId.Task:
            return TaskType.Task;
        case TaskTypeId.Issue:
            return TaskType.Issue;
        case TaskTypeId.Request:
            return TaskType.Request;
    }
};

export enum Keys {
    // Whitespace keys
    // see https://developer.mozilla.org/en-US/docs/Web/API/UI_Events/Keyboard_event_key_values#whitespace_keys
    Enter = "Enter",
    Tab = "Tab",
    Space = " ",

    // Navigation keys
    // see https://developer.mozilla.org/en-US/docs/Web/API/UI_Events/Keyboard_event_key_values#navigation_keys
    ArrowDown = "ArrowDown",
    ArrowUp = "ArrowUp",
    ArrowLeft = "ArrowLeft",
    ArrowRight = "ArrowRight",
    Home = "Home",
    End = "End",
    PageDown = "PageDown",
    PageUp = "PageUp",

    // Modifier keys
    // see https://developer.mozilla.org/en-US/docs/Web/API/UI_Events/Keyboard_event_key_values#modifier_keys
    Control = "Control",
    Shift = "Shift",

    // UI keys
    // see https://developer.mozilla.org/en-US/docs/Web/API/UI_Events/Keyboard_event_key_values#ui_keys
    Escape = "Escape",

    // Editing keys
    //see https://developer.mozilla.org/en-US/docs/Web/API/UI_Events/Keyboard_event_key_values#editing_keys
    Backspace = "Backspace",
}
